/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Import_TitleInputs */

const en_subtitle_import_title = /** @type {(inputs: Subtitle_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtitle Import`)
};

const fr_subtitle_import_title = /** @type {(inputs: Subtitle_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importation des sous-titres`)
};

const de_subtitle_import_title = /** @type {(inputs: Subtitle_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untertitel importieren`)
};

const it_subtitle_import_title = /** @type {(inputs: Subtitle_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importazione sottotitoli`)
};

const ru_subtitle_import_title = /** @type {(inputs: Subtitle_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт субтитров`)
};

const es_subtitle_import_title = /** @type {(inputs: Subtitle_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importación de subtítulos`)
};

const zh_cn2_subtitle_import_title = /** @type {(inputs: Subtitle_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕导入`)
};

const ja_subtitle_import_title = /** @type {(inputs: Subtitle_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕インポート`)
};

const hi_subtitle_import_title = /** @type {(inputs: Subtitle_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपशीर्षक आयात`)
};

const pt_pt2_subtitle_import_title = /** @type {(inputs: Subtitle_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importação de legendas`)
};

/**
* | output |
* | --- |
* | "Subtitle Import" |
*
* @param {Subtitle_Import_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_import_title = /** @type {((inputs?: Subtitle_Import_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Import_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_import_title(inputs)
	if (locale === "de") return de_subtitle_import_title(inputs)
	if (locale === "it") return it_subtitle_import_title(inputs)
	if (locale === "ru") return ru_subtitle_import_title(inputs)
	if (locale === "es") return es_subtitle_import_title(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_import_title(inputs)
	if (locale === "ja") return ja_subtitle_import_title(inputs)
	if (locale === "hi") return hi_subtitle_import_title(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_import_title(inputs)
	return en_subtitle_import_title(inputs)
});